/** @format */

import { Injectable, inject } from '@angular/core';

import { ActivatedRouteSnapshot } from '@angular/router';
import { HomrDataService } from '@shared/homr/data-access';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HomrContentResolve {
  private readonly homrService = inject(HomrDataService);

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    if (route.params['seoName']) {
      this.homrService.setPageName(route.params['seoName']);
      return this.homrService.getData$('static', 1, route.params['seoName'], true).pipe(
        catchError(() => {
          return new Observable(null);
        }),
      );
    }
    this.homrService.setPageName('homepage');
    return this.homrService.getData$('home', 1, 'homepage', true).pipe(
      catchError(() => {
        return new Observable(null);
      }),
    );
  }
}
